import { Controller } from "stimulus";

export default class extends Controller {
  toggle(event) {
    event.stopPropagation();
    const row = event.currentTarget.closest(".tg-week-row");
    this.setOpen(row, !row.classList.contains("tg-week-row-open"));
  }

  expand(event) {
    const row = event.target.closest(".tg-week-row");
    if (row) this.setOpen(row, true);
  }

  setOpen(row, open) {
    this.element.querySelectorAll(".tg-week-row-open").forEach((other) => {
      if (other !== row) this.mark(other, false);
    });
    this.mark(row, open);
  }

  mark(row, open) {
    row.classList.toggle("tg-week-row-open", open);
    row.querySelectorAll(".tg-week-more").forEach((button) => button.setAttribute("aria-expanded", open ? "true" : "false"));
  }
}
